module.exports = __webpack_public_path__ + "static/carousel3.ee1604ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/carousel/carousel3.jpg
// module id = 707
// module chunks = 168707334958949